import { useMediaQuery } from '@chakra-ui/react';

export const useIsMobile = (): boolean => {
  const [isMobile] = useMediaQuery('(max-width: 767px)');
  return isMobile;
};

export const useIsTablet = (): boolean => {
  const [isTablet] = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
  return isTablet;
};
